/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  fetchData,
  toasterrormsg,
  getNumberOfHours,
  toastsuccessmsg,
  formatNumber,
  useMenuIdPermissions,
  getEncryptedRoute,
} from '../../../reusable'
import { PageTitle } from '../../../_metronic/layout/core'
import { TablesWidget14 } from '../../../_metronic/partials/widgets'
import { ToastContainer } from 'react-toastify'
import { Tr } from '../../../_metronic/i18n/Tr'

const ViewSpaceBookingDetails = () => {
  let t = Tr()
  const { menuId, menuIdEdit } = useMenuIdPermissions()

  const location = useLocation()
  const [bookingDetails, setBookingDetails] = useState([]) as any
  const [booking, setBooking] = useState({}) as any

  const [userDetail, setUserDetail] = useState({}) as any
  const bookingId = (location.state as any)?.bookingId || ''

  const [rentableSpacePrice, setRentableSpacePrice] = useState('') as any
  const [extraCharge, setExtraCharge] = useState('') as any
  const [userPoints, setuserpoints] = useState('') as any
  // const [couponAmount, setCouponAmount] = useState('') as any
  const [preDiscountAmount, setPreDiscountAmount] = useState('') as any
  const [payableAmount, setPayableAmount] = useState('') as any
  const [couponType, setCouponType] = useState('') as any
  const [couponValue, setCouponValue] = useState('') as any
  const [couponDiscount, setCouponDiscount] = useState('') as any
  const [show, setShow] = useState('seeDetails') as any
  const [discountPerncentage, setDiscountPercentage] = useState('') as any
  const [point, setPoint] = useState('') as any
  const [totalCommission, setTotalCommission] = useState('') as any
  const [commissionRate, setCommissionRate] = useState('') as any

  const formatDate = (date: any) => {
    // Check if the date is a valid ISO string or a recognized format
    const momentDate = moment(date, moment.ISO_8601, true).isValid()
      ? moment(date) // If ISO format
      : moment(date, 'DD-MM-YYYY', true) // If custom format

    if (!momentDate.isValid()) {
      return 'INVALID DATE' // Handle invalid date cases
    }

    // Format the date
    return momentDate.format('ddd, DD MMM YYYY').toUpperCase()
  }
  // view profile api call

  const bookingDetailsApiCall = async () => {
    var param: any = {
      bookingId: bookingId,
      categoryId: '4',
    }

    var response: any = await fetchData('admin/bookingDetail', param)

    if (response.status == '200') {
      var data = response.data[0]

      setUserDetail(data['userDetail'][0])
      setBooking(data)

      var totalAmount: any = Number(data.totalAmount)
      var extraCharge: any = Number(data.extraCharge)
      var finalPrice = totalAmount - extraCharge
      setRentableSpacePrice(finalPrice)
      setExtraCharge(data.extraCharge)
      setuserpoints(data.pointAmount)
      setCommissionRate(data.insayrServiceRate)
      setTotalCommission(data.insayrServiceFee)

      // setCouponAmount(data[0].couponDiscount)
      setPreDiscountAmount(data.discount)
      setPayableAmount(data.totalAmount)
      setBookingDetails(data['bookingDetail'])
      setPoint(data['point'])
      setCouponDiscount(data['couponDiscount'])

      var couponData = data['couponDetail'] ? data['couponDetail'] : ''


      if (couponData != undefined && couponData != null && couponData != '') {
        setCouponType(couponData['couponType'] ? couponData['couponType'] : '')
        setCouponValue(couponData['couponValue'])
      }
      // if (data.subTotal != '' && data.discount != '') {
      //   var discount = Number(data.discount)
      //   var subTotal = Number(data.subTotal)

      //   setDiscountPercentage((discount / subTotal) * 100)
      // }
      setDiscountPercentage(data['bookingDetail'][0].vendorDiscountPercentage)
    } else {
      toasterrormsg(response.message)
    }
  }

  const calculateTotal = () => {
    if (couponValue != '') {
      if (extraCharge != '' && extraCharge != '0' && couponValue != '' && couponValue != '0') {
        var totalAmount = parseFloat(extraCharge) + parseFloat(rentableSpacePrice)
        if (couponType == 'PERCENTAGE') {
          setCouponDiscount((totalAmount * 10) / 100)
          var discountAmount = totalAmount - (totalAmount * 10) / 100

          if (preDiscountAmount != '' && preDiscountAmount != '0') {
            var preDiscountAmountTwo = Number(preDiscountAmount)

            var finalAmount = discountAmount - preDiscountAmountTwo
            setPayableAmount(finalAmount)
            // setPayableAmount(roomPrice)
          } else {
            setPayableAmount(discountAmount)
          }
        } else {
          var totalAmount = Number(totalAmount)
          var couponDiscount = Number(couponValue)
          var totalPrice = totalAmount - couponDiscount

          if (preDiscountAmount != '' && preDiscountAmount != '0') {
            var preDiscountAmountTwo = Number(preDiscountAmount)

            var finalAmount = totalPrice - preDiscountAmountTwo
            setPayableAmount(finalAmount)
            // setPayableAmount(roomPrice)
          } else {
            setPayableAmount(totalPrice)
          }
        }
      } else if (extraCharge == '' || (extraCharge == '0' && couponValue != '')) {
        if (couponType == 'FIXED') {
          var roomPriceNumber = Number(rentableSpacePrice)
          var couponDiscount = Number(couponValue)
          var totalPrice = roomPriceNumber - couponDiscount

          if (preDiscountAmount != '' && preDiscountAmount != '0') {
            var preDiscountAmountTwo = Number(preDiscountAmount)

            var finalAmount = totalPrice - preDiscountAmountTwo
            setPayableAmount(finalAmount)
            // setPayableAmount(roomPrice)
          } else {
            setPayableAmount(totalPrice)
          }
        } else {
          setCouponDiscount((rentableSpacePrice * 10) / 100)
          var discountAmount = rentableSpacePrice - (rentableSpacePrice * 10) / 100

          if (preDiscountAmount != '' && preDiscountAmount != '0') {
            var preDiscountAmountTwo = Number(preDiscountAmount)

            var finalAmount = discountAmount - preDiscountAmountTwo
            setPayableAmount(finalAmount)
            // setPayableAmount(roomPrice)
          } else {
            setPayableAmount(discountAmount)
          }
        }
      } else {
        if (preDiscountAmount != '' && preDiscountAmount != '0') {
          var payableAmountTwo = Number(payableAmount)
          var preDiscountAmountTwo = Number(preDiscountAmount)

          var finalAmount = payableAmountTwo - preDiscountAmountTwo
          setPayableAmount(finalAmount)
          // setPayableAmount(roomPrice)
        } else {
          setPayableAmount(rentableSpacePrice)
        }
      }
    } else {
      if (extraCharge != '' && extraCharge != '0') {
        var totalAmount = parseFloat(extraCharge) + parseFloat(rentableSpacePrice)
        if (preDiscountAmount != '' && preDiscountAmount != '0') {
          var preDiscountAmountTwo = Number(preDiscountAmount)

          var finalAmount = totalAmount - preDiscountAmountTwo
          setPayableAmount(finalAmount)
        } else {
          setPayableAmount(totalAmount)
        }
      } else {
        if (preDiscountAmount != '' && preDiscountAmount != '0') {
          var payableAmountTwo = Number(rentableSpacePrice)
          var preDiscountAmountTwo = Number(preDiscountAmount)

          var finalAmount = payableAmountTwo - preDiscountAmountTwo
          setPayableAmount(finalAmount)
        } else {
          setPayableAmount(rentableSpacePrice)
        }
      }
    }
  }

  const savePayment = async () => {
    if (parseFloat(payableAmount) > 0) {
      var tmp2 = sessionStorage.getItem('admin')
      // Step 2: Check if the item is not null
      if (tmp2) {
        // Step 3: Parse the JSON string
        var adminData = JSON.parse(tmp2)
        // Step 4: Access the adminId
        var adminId = adminData.adminId
      }
      var param: any = {
        updateStatus: '2',
        bookingId: String(bookingId),
        paybaleAmount: payableAmount,
        extracharge: extraCharge,
        couponDiscount: couponDiscount,
        adminId: adminId,
        bookingdetailId: String(bookingDetails[0]['bookingdetailId']),
      }
      var response = await fetchData('admin/editrentablespacebooking', param)

      if (response.status == '200') {
        toastsuccessmsg('Updated Successfully')
        bookingDetailsApiCall()
        setShow('seeDetails')
      } else {
      }
    } else {
      toasterrormsg("Final Amount can't be negative")
    }
  }

  useEffect(() => {
    bookingDetailsApiCall()
    document.title = 'Insayr | Space Rental Booking Details'
  }, [bookingId])

  return (
    <>
      <ToastContainer />

      <PageTitle breadcrumbs={[]}>{t('View Booking Details')}</PageTitle>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>{t('Booking Details')}</h3>
          </div>
        </div>
        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{t('Booking Id')}</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>#{booking['bookingCode']}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{t('User Name')}</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>
                {userDetail && userDetail['fullName']}
              </span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{t('Date Booked')}</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{formatDate(booking['created'])}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{t('Customer Location')}</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>
                {userDetail && userDetail['location']}
              </span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{t('Payment Method')}</label>
            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>
                {booking['paymentMethod'] ? booking['paymentMethod'] : ''}
              </span>
            </div>
          </div>
          {/* {booking['bookingDetail'] && booking['bookingDetail'][0].cancellationAmount != '' ? (
            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Cancellation Charge</label>
              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {booking['bookingDetail']
                    ? formatNumber(booking['bookingDetail'][0].cancellationAmount)
                    : ''}{' '}
                  (
                  {booking['bookingDetail']
                    ? booking['bookingDetail'][0].cancellationPercentage + '%'
                    : ''}
                  )
                </span>
              </div>
            </div>
          ) : (
            ''
          )} */}
        </div>
      </div>
      {bookingDetails.map((detail: any, index: any) => {
        var primaryLanguage = detail['actionDetail'][0]['primaryLanguage'] || ''
        var spaceName = ''
        var spaceType = ''
        if (primaryLanguage == 'English') {
          spaceName = detail['actionDetail'][0]['en_name']
          spaceType = detail['actionDetail'][0]['subcategoryDetail']
            ? detail['actionDetail'][0]['subcategoryDetail'][0]['en_name']
            : ''
        } else if (primaryLanguage == 'Russian') {
          spaceName = detail['actionDetail'][0]['ru_name']
          spaceType = detail['actionDetail'][0]['subcategoryDetail']
            ? detail['actionDetail'][0]['subcategoryDetail'][0]['ru_name']
            : ''
        } else if (primaryLanguage == 'Uzbek') {
          spaceName = detail['actionDetail'][0]['uz_name']
          spaceType = detail['actionDetail'][0]['subcategoryDetail']
            ? detail['actionDetail'][0]['subcategoryDetail'][0]['uz_name']
            : ''
        }

        return (
          <div className='card mb-5 mb-xl-10' id='kt_profile_details_view' key={index}>
            <div className='card-header'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{t('Booked Rental Space')}</span>
              </h3>
              <h3 className='card-title align-items-start flex-column'>
                {menuIdEdit ? (
                  <Link
                    to={getEncryptedRoute('../editspacebookingdetails/', { menuId: menuId })}
                    state={{
                      bookingId: detail['bookingId'],
                      bookingdetailId: detail['bookingdetailId'],
                    }}
                  >
                    <button className='btn btn-success '>{t('Edit Booking')}</button>
                  </Link>
                ) : (
                  ''
                )}
              </h3>
            </div>
            <div className='card-body p-9'>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Space Type')}</label>

                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>{spaceType}</span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Space Name')}</label>

                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>{spaceName}</span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Rental Space Name')}</label>

                <div className='col-lg-8'>
                  {detail['actionTypeDetail'].map((actionTypeDetail: any, index: any) => {
                    if (primaryLanguage == 'English') {
                      return (
                        <div key={index} className='fw-bolder fs-6 text-dark mt-0'>
                          {actionTypeDetail['en_name']}
                          {index !== detail['actionTypeDetail'].length - 1 ? ', ' : ''}
                        </div>
                      )
                    } else if (primaryLanguage == 'Russian') {
                      return (
                        <div key={index} className='fw-bolder fs-6 text-dark mt-0'>
                          {actionTypeDetail['ru_name']}
                          {index !== detail['actionTypeDetail'].length - 1 ? ', ' : ''}
                        </div>
                      )
                    } else if (primaryLanguage == 'Uzbek') {
                      return (
                        <div key={index} className='fw-bolder fs-6 text-dark mt-0'>
                          {actionTypeDetail['uz_name']}
                          {index !== detail['actionTypeDetail'].length - 1 ? ', ' : ''}
                        </div>
                      )
                    }
                  })}
                  <span className='fw-bolder fs-6 text-dark'></span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Total Spaces')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {detail['actionTypeDetail'].length}
                  </span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('No Of People')}</label>
                <div className='col-lg-8'>
                  <label className='fw-bold text-muted'>{t('People:')}</label>
                  <span className='fw-bolder fs-6 text-dark mx-3'>{detail['people']}</span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('By people / By time')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {detail['bookingType'] == 'byPeople'
                      ? t('By People')
                      : detail['fromTime'] && detail['toTime']
                        ? t('By Time')
                        : t('By People')}
                  </span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Renting Date')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {detail['rentingDate'] ? formatDate(detail['rentingDate']) : ''}
                  </span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Renting Hours')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {detail['fromTime'] && detail['toTime']
                      ? moment(detail['fromTime'], 'HH:mm:ss').format('HH:mm') +
                      ' - ' +
                      moment(detail['toTime'], 'HH:mm:ss').format('HH:mm')
                      : '-'}
                  </span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>{t('Length Of Use')}</label>
                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>
                    {detail['fromTime'] && detail['toTime']
                      ? getNumberOfHours(detail['fromTime'], detail['toTime']) + ' ' + t('Hours')
                      : '-'}
                  </span>
                </div>
              </div>
              <div className='row'>
                <div className='col-lg-12'>
                  <TablesWidget14
                    className='card-xl-stretch mb-5 mb-xl-8'
                    title={t('Guest Info')}
                    data={detail['guestInfo']}
                  />
                </div>
              </div>
            </div>
          </div>
        )
      })}

      {show == 'seeDetails' ? (
        <div className='row'>
          <div className='col-lg-6'>
            <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
              <div className='card-header'>
                <div className='card-title m-0'>
                  <h3 className='fw-bolder m-0'>{t('Payment Details')}</h3>
                </div>

                <div className='card-title m-0'>
                  {booking.status == 2 ? (
                    <span className='badge badge-light-danger mx-2'>{t('Rejected')}</span>
                  ) : booking.status == 3 ? (
                    <span className='badge badge-danger bg-danger mx-2 '>{t('Cancelled')}</span>
                  ) : booking.status == 1 ? (
                    <span className='badge badge-success mx-2'>{t('Approved')}</span>
                  ) : booking.status == 4 ? (
                    <span className='badge badge-success mx-2'>{t('Completed')}</span>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className='card-body p-9'>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>{t('Original Amount')}</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {booking.subTotal != ''
                        ? formatNumber(parseFloat(booking.subTotal))
                        : '0 UZS'}
                    </span>
                  </div>
                </div>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>{t('Extra People Charge')}</label>
                  <div className='col-lg-8'>
                    {/* Total Charge Calculation */}
                    <span className='fw-bolder fs-6 text-dark'>
                      {bookingDetails.length > 0 && bookingDetails[0]
                        ? bookingDetails[0].extraPeople &&
                          bookingDetails[0].extraPeople !== '0' &&
                          bookingDetails[0].extraPeopleCharge &&
                          bookingDetails[0].extraPeopleCharge !== '0'
                          ? formatNumber(
                            parseFloat(bookingDetails[0].extraPeopleCharge) *
                            parseFloat(bookingDetails[0].extraPeople)
                          )
                          : 0
                        : '0'}{' '}
                    </span>

                    {/* Breakdown Display */}
                    <span className='fw-bolder fs-7 text-dark'>
                      {bookingDetails.length > 0 &&
                        bookingDetails[0] &&
                        bookingDetails[0].extraPeople &&
                        bookingDetails[0].extraPeople !== '' &&
                        bookingDetails[0].extraPeopleCharge &&
                        bookingDetails[0].extraPeopleCharge !== ''
                        ? ` (${bookingDetails[0].extraPeople} x ${formatNumber(
                          bookingDetails[0].extraPeopleCharge
                        )})`
                        : ' (0 x 0)'}
                    </span>
                  </div>
                </div>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>{t('Extra Charge')}</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {extraCharge == ''
                        ? 0 + ' UZS'
                        : formatNumber(parseFloat(booking['extraCharge']))}
                    </span>
                  </div>
                </div>

                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>{t('User Points')}</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {userPoints == '' ? 0 : formatNumber(parseFloat(booking['pointAmount']))}
                    </span>
                    {/* {/ <span className='fw-bold fs-7'> (1,500 points)</span> /} */}
                    <span className='fw-bold fs-7'> ({booking['point'] + ' ' + t('points')})</span>
                  </div>
                </div>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>{t('Coupon Amount')}</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {couponDiscount == '' || couponDiscount == undefined || couponDiscount == null
                        ? 0
                        : formatNumber(parseFloat(couponDiscount))}{' '}
                    </span>
                    {/* {/ <span className='fw-bold fs-7'> (10% OFF coupon OR 15,000 UZS coupon)</span> /} */}
                    <span className='fw-bolder fs-7 text-dark'>
                      {' '}
                      ({couponValue} {" "}
                      {couponType == 'FIXED'
                        ? t('UZS Coupon')
                        : couponType == 'PERCENTAGE'
                          ? t('% OFF Coupon')
                          : t('No Coupon Applied')}
                      )
                    </span>{' '}
                  </div>
                </div>
                <div className='row mb-7 pb-5 border-bottom border-gray-300'>
                  <label className='col-lg-4 fw-bold text-muted'>{t('Discount Amount')}</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {bookingDetails[0] &&
                        !isNaN(Number(bookingDetails[0].specialDiscount)) &&
                        Number(bookingDetails[0].specialDiscount) > 0
                        ? formatNumber(Number(bookingDetails[0].specialDiscount))
                        : bookingDetails[0] &&
                          !isNaN(Number(bookingDetails[0].discount)) &&
                          Number(bookingDetails[0].discount) > 0
                          ? formatNumber(Number(bookingDetails[0].discount))
                          : "0 UZS"
                      }{" "}
                    </span>
                    <span className='fw-bolder fs-7 text-dark'>
                      {' '}
                      (
                      {bookingDetails[0] != undefined &&
                        bookingDetails[0] != null &&
                        bookingDetails[0] != '' &&
                        bookingDetails[0].specialDiscount == 0
                        ? discountPerncentage != ''
                          ? discountPerncentage.toFixed(2) + ' % discount'
                          : t('0 % discount')
                        : t('Special Discount')}
                      )
                    </span>{' '}
                  </div>
                </div>
                {booking['status'] == 3 && (
                  <>
                    <div className='row py-3 border-bottom border-gray-300'>
                      <label className='col-lg-4 fw-bold'>{t('Total Paid')}</label>
                      <div className='col-lg-8'>
                        <span className='fw-bolder fs-6 text-dark'>
                          {formatNumber(parseFloat(booking['totalPaid']))}
                        </span>
                      </div>
                    </div>
                    <div className='row py-3 border-bottom border-gray-300 text-danger'>
                      <label className='col-lg-4 fw-bold'>{t('Cancellation Amount')}</label>
                      <div className='col-lg-8'>
                        <span className='fw-bolder fs-6'>
                          -{' '}
                          {formatNumber(
                            parseFloat(booking['bookingDetail'][0]['cancellationAmount'])
                          )}{' '}
                        </span>
                        <span className='fw-bold fs-7'>
                          {' '}
                          ({booking['bookingDetail'][0]['cancellationPercentage'].toFixed(2)}{' '}
                          {t('% refund')})
                        </span>
                      </div>
                    </div>
                  </>
                )}

                {booking['status'] == 2 ? (
                  <>
                    <div className='row py-3 border-bottom border-gray-300'>
                      <label className='col-lg-4 fw-bold'>{t('Total Paid')}</label>
                      <div className='col-lg-8'>
                        <span className='fw-bolder fs-6 text-dark'>
                          {formatNumber(parseFloat(booking['totalPaid']))}
                        </span>
                      </div>
                    </div>
                    <div className='row py-3 border-bottom border-gray-300 text-danger'>
                      <label className='col-lg-4 fw-bold'>{t('Refundable Amount')}</label>
                      <div className='col-lg-8'>
                        <span className='fw-bolder fs-6'>
                          -{' '}
                          {formatNumber(
                            parseFloat(booking['bookingDetail'][0]['cancellationAmount'])
                          )}{' '}
                        </span>
                        <span className='fw-bold fs-7'>
                          {' '}
                          ({booking['bookingDetail'][0]['cancellationPercentage'].toFixed(2)}{' '}
                          {t('% refund')})
                        </span>
                      </div>
                    </div>
                  </>
                ) : (
                  ''
                )}
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold fs-6'>{t('Final Amount')}</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {formatNumber(parseFloat(booking['totalAmount']))}
                    </span>
                    {booking.isEdit == 1 ? (
                      <span className='badge badge-secondary mx-2 fs-6 '>Edited</span>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='col-lg-6'>
            <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
              <div className='card-header'>
                <div className='card-title m-0'>
                  <h3 className='fw-bolder m-0'>{t('Insayr Commission')}</h3>
                </div>
                <div className='card-title m-0'></div>
              </div>
              <div className='card-body p-9'>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>{t('INSAYR Service Fee')}</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {commissionRate != '' ? commissionRate + '%' : ''}
                    </span>
                  </div>
                </div>

                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>
                    {t('INSAYR Service Amount')}
                  </label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {totalCommission != '' &&
                        totalCommission != undefined &&
                        totalCommission != null
                        ? formatNumber(parseFloat(totalCommission))
                        : '0 UZS'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className='row'>
          <div className='col-lg-6'>
            <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
              <div className='card-header'>
                <div className='card-title m-0'>
                  <h3 className='fw-bolder m-0'>Original Amount</h3>
                </div>
              </div>
              <div className='card-body p-9'>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>Original Amount</label>
                  <div className='col-lg-8'>
                    <input
                      type='text'
                      className='border-0'
                      value={rentableSpacePrice}
                      disabled={show == 'seeDetails' ? true : false}
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: 'lightgray',
                        padding: '0.5rem',
                        borderRadius: '0.5rem',
                        outline: 'none',
                      }}
                      onChange={(e) => {
                        const value: any = e.target.value

                        // Check if the value is a valid number or empty (to allow clearing input)
                        if (!isNaN(value) || value === '') {
                          setRentableSpacePrice(value) // Set the state only if it's a valid number
                        }
                      }}
                      onKeyDown={() => {
                        calculateTotal()
                      }}
                      onKeyUp={() => {
                        calculateTotal()
                      }}
                    />
                    <span className='fw-bolder fs-6 text-dark'> UZS</span>
                  </div>
                </div>

                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>Extra Charge</label>
                  <div className='col-lg-8'>
                    <input
                      type='text'
                      value={extraCharge || 0}
                      disabled={show == 'seeDetails' ? true : false}
                      className='border-0 '
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: 'lightgray',
                        padding: '0.5rem',
                        borderRadius: '0.5rem',
                        outline: 'none',
                      }}
                      onChange={(e) => {
                        const value: any = e.target.value

                        // Check if the value is a valid number or empty (to allow clearing input)
                        if (!isNaN(value) || value === '') {
                          setExtraCharge(value) // Set the state only if it's a valid number
                        }
                      }}
                      onKeyDown={() => {
                        calculateTotal()
                      }}
                      onKeyUp={() => {
                        calculateTotal()
                      }}
                    />

                    <span className='fw-bolder fs-6 text-dark'> UZS</span>
                  </div>
                </div>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>User Points</label>
                  <div className='col-lg-8'>
                    <input
                      type='text'
                      disabled={true}
                      value={userPoints || 0}
                      className='border-0 '
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: 'lightgray',
                        padding: '0.5rem',
                        borderRadius: '0.5rem',
                        outline: 'none',
                      }}
                    />
                    <span className='fw-bolder fs-6 text-dark'>
                      {' '}
                      ({`${point == '' ? 0 : point} points`})
                    </span>
                  </div>
                </div>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>Coupon Discount</label>
                  <div className='col-lg-8'>
                    <input
                      type='text'
                      disabled={true}
                      value={couponDiscount || 0}
                      className='border-0 '
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: 'lightgray',
                        padding: '0.5rem',
                        borderRadius: '0.5rem',
                        outline: 'none',
                      }}
                    />
                    <span className='fw-bolder fs-6 text-dark'>
                      {' '}
                      ({couponValue}
                      {couponType == 'FIXED'
                        ? ' UZS Coupon'
                        : couponType == 'PERCENTAGE'
                          ? '% OFF Coupon'
                          : 'No Coupon Applied'}
                      )
                    </span>
                    {/* <span className='fw-bold fs-7'> (10% OFF coupon OR 15,000 UZS coupon)</span> */}
                  </div>
                </div>
                <div className='row mb-7 pb-5 border-bottom border-gray-300'>
                  <label className='col-lg-4 fw-bold text-muted'>Discount Amount</label>
                  <div className='col-lg-8'>
                    <input
                      type='text'
                      disabled={true}
                      value={preDiscountAmount || 0}
                      className='border-0 '
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: 'lightgray',
                        padding: '0.5rem',
                        borderRadius: '0.5rem',
                        outline: 'none',
                      }}
                    />
                    <span className='fw-bolder fs-7 text-dark'>
                      {' '}
                      ({discountPerncentage != '' ? discountPerncentage.toFixed(2) : '0'}% discount)
                    </span>
                  </div>
                </div>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold fs-6'>Final Amount</label>
                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>{payableAmount} UZS</span>
                    {booking.isEdit == 1 ? (
                      <span className='badge badge-secondary mx-2 fs-6 '>Edited</span>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                {show != 'seeDetails' ? (
                  <button
                    className='btn btn-success'
                    onClick={() => {
                      savePayment()
                    }}
                  >
                    Save
                  </button>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export { ViewSpaceBookingDetails }
